import { render, staticRenderFns } from "./PricingTable.vue?vue&type=template&id=9468c228&scoped=true&"
import script from "./PricingTable.vue?vue&type=script&lang=ts&"
export * from "./PricingTable.vue?vue&type=script&lang=ts&"
import style0 from "./PricingTable.vue?vue&type=style&index=0&id=9468c228&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9468c228",
  null
  
)

export default component.exports